import { FC, ReactElement, ReactNode } from 'react'
import { styled } from '@mui/material/styles'
import { Button, buttonClasses, Theme, useMediaQuery } from '@mui/material'
import { PersonIcon, EditIcon } from 'src/components/icons'
import { usePushNotification } from '@/hooks'
import { BadgeWithCount } from '@/components/icons/BadgeWithCount'

const StyledButton = styled(Button)(({ theme }) => ({
  [`&.${buttonClasses.root}`]: {
    minWidth: 'initial',
    marginRight: -8,
    position: 'relative',
  },
  [`&.${buttonClasses.text}`]: {
    ...theme.typography.body1,
    textTransform: 'initial',
    color: theme.custom.colors.common.black,
  },
  [`.${buttonClasses.startIcon}`]: {
    marginLeft: 0,
    marginRight: 0,

    [theme.breakpoints.up('sm')]: {
      marginRight: 8,
    },
  },
}))

interface HasClick {
  onClick: () => void
}

interface HeaderButtonProps {
  icon: ReactElement
  badge?: ReactElement
}

export const HeaderButton: FC<HeaderButtonProps & HasClick & { children: ReactNode }> = (props) => {
  const { icon, onClick, children } = props

  return (
    <StyledButton startIcon={icon} onClick={onClick}>
      {children}
    </StyledButton>
  )
}

export const HeaderMenuButton: FC<HasClick> = (props) => {
  const { onClick } = props
  const isLarge = useMediaQuery<Theme>(({ breakpoints }) => breakpoints.up('sm'))

  const { unreadCount, isReady } = usePushNotification()

  return (
    <HeaderButton icon={<PersonIcon />} onClick={onClick}>
      {isReady && unreadCount > 0 && <BadgeWithCount placement="icon" count={unreadCount} />}
      {isLarge && 'Menu'}
    </HeaderButton>
  )
}

export const HeaderEditButton: FC<HasClick> = (props) => {
  const { onClick } = props
  return (
    <HeaderButton icon={<EditIcon />} onClick={onClick}>
      Edit
    </HeaderButton>
  )
}
